import React, { useState } from 'react'

// Local Imports
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'

// API services
import { usePutLeavePolicyStatus } from 'services/api/modules/leave/leavePolicy'
import AdxButton from 'components/custom/AdxButton'

const LeavePolicyModal = ({ status, item }) => {
  const [modalState, setModalState] = useState(false)
  const mutation = usePutLeavePolicyStatus()

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  const handleChange = () => {
    if (status === 1) {
      // API to mutate status here
      mutation.mutate(
        { status: 2, id: item.id, type: item.type },
        {
          onSuccess: () => handleClose(),
        }
      )
    } else {
      // API to mutate status here
      mutation.mutate(
        { status: 1, id: item.id, type: item.type },
        {
          onSuccess: () => handleClose(),
        }
      )
    }
  }

  return (
    <>
      <AdxSwitch state={status === 1 ? true : false} onClick={handleOpen}></AdxSwitch>
      <AdxInfoModal
        title={
          status === 2 ? `Enable ${item.name}${' '}policy?` : `Disable ${item.name}${' '}policy?`
        }
        subtitle="Changes may affect settings"
        muiIcon="error"
        iconColor={status === 2 ? 'info.main' : 'error.main'}
        open={modalState}
        onClose={handleClose}
      >
        {status === 2 ? (
          <AdxButton
            variant={'contained'}
            color="alternate"
            fullWidth
            onClick={handleChange}
            type="submit"
          >
            Enable
          </AdxButton>
        ) : (
          <AdxButton
            variant={'outlined'}
            color="error"
            fullWidth
            onClick={handleChange}
            type="submit"
            sx={{
              '&:hover': {
                backgroundColor: 'light-error.main',
                color: 'error.main',
              },
            }}
          >
            Disable
          </AdxButton>
        )}

        <AdxButton variant={'ghost'} fullWidth onClick={handleClose}>
          Cancel
        </AdxButton>
      </AdxInfoModal>
    </>
  )
}

export default LeavePolicyModal
